/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Proof_HInputs */

const en_funnel_ob_proof_h = /** @type {(inputs: Funnel_Ob_Proof_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loved by students & researchers worldwide.`)
};

const es_funnel_ob_proof_h = /** @type {(inputs: Funnel_Ob_Proof_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con el cariño de estudiantes e investigadores de todo el mundo.`)
};

/**
* | output |
* | --- |
* | "Loved by students & researchers worldwide." |
*
* @param {Funnel_Ob_Proof_HInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_proof_h = /** @type {((inputs?: Funnel_Ob_Proof_HInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Proof_HInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_proof_h(inputs)
	return en_funnel_ob_proof_h(inputs)
});